export const BEST_DEALS_MARKETS = Object.freeze({
  'miami-fl': Object.freeze({
    slug: 'miami-fl',
    city: 'Miami',
    state: 'Florida',
    stateCode: 'FL',
    centerZip: '33131',
    radius: '50',
    path: '/used-cars/miami-fl/best-deals',
    canonicalUrl: 'https://meshum.com/used-cars/miami-fl/best-deals',
    title: 'Best Used Car Deals in Miami, FL | Meshum',
    heading: 'Best Used Car Deals in Miami, FL',
    description: 'Find the best used car deals near Miami, FL—vehicles priced below Meshum Estimate, with market values supported by recently sold comparable vehicles.',
  }),
});

export function getBestDealsMarket(slug) {
  return BEST_DEALS_MARKETS[String(slug || '').toLowerCase()] || null;
}
